import React, { useEffect, useState } from "react";
import DemoInterestedSection from "../../Component/DemoInterestedSection";
import BookaDemoBox from "../../Component/BoxComponent/BookaDemoBox";
import AskusAnythingBox from "../../Component/BoxComponent/AskusAnythingBox";
import ContactBannerSection from "./component/ContactBannerSection";
import OurLocationSection from "./component/OurLocationSection";

function ContactUsPage() {
  const [acfData, setAcfData] = useState(null);
  const onRefresh = async () => {
    try {
      const response = await fetch(
        "https://www.lagunacreek.io/blog/wp-json/custom/v1/acf-data/contact-us"
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const source = await response.json();
      const acf_fields = source?.acf_fields;
      setAcfData(acf_fields);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    onRefresh();
  }, []);

  return (
    <>
      <ContactBannerSection contact_banner={acfData?.contact_banner} />
      <OurLocationSection our_location={acfData?.our_location} />
      <DemoInterestedSection acfData={acfData} />
    </>
  );
}

export default ContactUsPage;
